import Component from '../component';
import {TweenMax} from "gsap/esm/TweenMax";

export default class Tabs extends Component {
	constructor(...args) {
		super(...args);
		this._retrieveDom();

		this._currentShow = 0;

	}

	_retrieveDom() {
		this.dom.label = this.dom.component.querySelectorAll('.js-tab-label');
		this.dom.content = this.dom.component.querySelectorAll('.js-tab-content');
		this.dom.bg = this.dom.component.querySelector('.js-bg');
		if (this.dom.bg) {
			this.dom.img = this.dom.bg.querySelectorAll('.js-img');
		}
	}

	bind() {
		super.bind();

		for (let i = 0; i < this.dom.label.length; i++) {
			let el = this.dom.label[i];
			el.addEventListener('click', this._process.bind(this, i));
		}
	}

	_process(index) {
		if (ENV.template == 'desktop') {

			this._clear(index);

		} else {

			if (this.dom.label[index].classList.contains('active')) {
				this.dom.label[index].classList.remove('active');
				this.dom.content[index].classList.remove('active');
				return;
			}

			this._show(index);

			var posTop = this.getCoords(this.dom.content[index]).top - 100;
			window.scrollTo(0, posTop);
		}
	}

	_clear(index) {

		this.dom.label[ this._currentShow ].classList.remove('active');

		TweenMax.to( this.dom.content[ this._currentShow ], 0.5, {autoAlpha: 0, ease: Power3.easeInOut, onComplete: () => {
				this.dom.content[ this._currentShow ].classList.remove('active');
				this._show(index);
			}});

		if (this.dom.bg) {
			this.dom.img[ this._currentShow ].classList.remove('active');
		}

		// for (let i = 0; i < this.dom.label.length; i++) {
		// 	this.dom.label[i].classList.remove('active');
		// 	TweenMax.to( this.dom.content[i], 0.5, {autoAlpha: 0, ease: Power3.easeInOut, onComplete: () => {
		// 		this.dom.content[i].classList.remove('active');
		// 		this._show(index);
		// 	}});
		//
		// 	if (this.dom.bg) {
		// 		this.dom.img[i].classList.remove('active');
		// 	}
		// }
	}

	_show(index) {
		if (this.dom.bg) {
			this.dom.img[index].classList.add('active');
		}

		this.dom.label[index].classList.add('active');

		this.dom.content[index].classList.add('active');
		TweenMax.fromTo( this.dom.content[index], 0.5,{autoAlpha:0}, {autoAlpha: 1, ease: Power3.easeInOut, onComplete: ()=> {
			console.log(this.dom.content[index]);
			} } );

		this._currentShow = index;
	}

	getCoords(elem) {
		var box = elem.getBoundingClientRect();
	
		var body = document.body;
		var docEl = document.documentElement;
	
		var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
		var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
	
		var clientTop = docEl.clientTop || body.clientTop || 0;
		var clientLeft = docEl.clientLeft || body.clientLeft || 0;
	
		var top  = box.top +  scrollTop - clientTop;
		var left = box.left + scrollLeft - clientLeft;
	
		return { top: Math.round(top), left: Math.round(left) };
	}

	/*
	init() {
	}
	bind() {
	}
	unbind() {
	}
	resize(width, height) {
	}
	*/
}



// WEBPACK FOOTER //
// ./src/js/components/tabs/tabs.js